import React from 'react';
import PeriodicBasedBudget from './PeriodicBasedBudget';
import MilestonesBasedBudget from './MilestonesBasedBudget';
import { useShowContext } from 'framework/show';
import EmptyBudgetComponent from './EmptyBudgetComponent';
import { BillingType } from 'domain/shared/newProject';

const BudgetRenderer = () => {
  const { data } = useShowContext();

  const budgetComponents: Record<BillingType, React.ComponentType> = {
    PERIODIC_PREPAID: PeriodicBasedBudget,
    PERIODIC_POSTPAID: PeriodicBasedBudget,
    MILESTONE: MilestonesBasedBudget,
  };

  const billingType = data.result?.[0]?.billingType as BillingType;
  const BudgetComponent = budgetComponents[billingType];

  return BudgetComponent ? (
    <BudgetComponent />
  ) : (
    <EmptyBudgetComponent
      alertType={data.result?.length ? 'warning' : 'info'}
      alertText={data.result?.length ? `Unknown billing type: ${billingType}` : 'No budget data available'}
    />
  );
};

export default BudgetRenderer;
